import { render, staticRenderFns } from "./MyCompletionRate.vue?vue&type=template&id=486d96ef&scoped=true"
import script from "./MyCompletionRate.vue?vue&type=script&lang=js"
export * from "./MyCompletionRate.vue?vue&type=script&lang=js"
import style0 from "./MyCompletionRate.vue?vue&type=style&index=0&id=486d96ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486d96ef",
  null
  
)

export default component.exports